'use client';

import { useEffect } from 'react';
import { initTrack } from '@/utils/track';

export function TrackingEffects() {
  // 异步初始化数数科技埋点
  const initializeTracking = async () => {
    await initTrack();
  };

  useEffect(() => {
    initializeTracking();
  }, []);

  return null;
}
